import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Typography, Box ,Grid,Card} from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import FAQ from "./FAQ";
import EquipmentCards from "./EquipmentCards";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";


const ProductDetail = () => {
  const { t } = useTranslation();
  const { id } = useParams();
 

  const getProducts = (t) => [
    {
      id: 1, 
      name: t("product.product_1.name"),
      description:t("product.product_1.description"),
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/netapro1.png",
      additionalImage: "https://www.remora.com.tr/wp-content/uploads/2024/05/Goruntu-16.04.2024-11.08-scaled-e1715327213932.jpeg",
      
      images: [
        "https://www.remora.com.tr/wp-content/uploads/2025/05/IMG_1774-scaled-1.jpeg",
        "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_1743-scaled.jpeg",
        "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_1817-scaled.jpeg",
        "https://www.remora.com.tr/wp-content/uploads/2024/05/IMG_1741-scaled.jpeg"
      ],
      details: t("product.product_1.details"),
      specifications: {
        girişGüçKaynağı: "220 V AC 50/60 Hz",
        çıkışGüçKaynağı: "24 V DC",
        güçTüketimi: "740W",
        hariciGüçKutusuBoyutları: "41cm x 34cm x 21cm",
        temizlemeKapasitesi: "7 m²/dk",
        kabloUzunluğu: "30 m",
        fırçaDeğiştirilebilir:  t("product.yes"),
      },
      technicalInfo: {
        ağırlık: "9,5 kg",
        robotölçüleri: "42cm x 42cm x 22cm",
        filtreHacmi: "42 cm³",
      },
    },
    {
      id: 2,
      name: t("product.product_2.name"),
      description: t("product.product_2.description"),
      image: "https://www.remora.com.tr/wp-content/uploads/2024/05/Konu-70.png",
      additionalImage:"https://www.remora.com.tr/wp-content/uploads/2025/05/1.jpg",
      Image2: "https://www.remora.com.tr/wp-content/uploads/2025/03/Ekran-goruntusu_21-3-2025_162544_drive.google.com_.jpeg",
      
      
      images: [
        "https://www.remora.com.tr/wp-content/uploads/2024/05/Konu-57.png",
        "https://www.remora.com.tr/wp-content/uploads/2024/05/Konu-70.png",
        "https://www.remora.com.tr/wp-content/uploads/2025/05/Konu-56-Photoroom.png-Photoroom.png",
        "https://www.remora.com.tr/wp-content/uploads/2025/05/6.jpg",
        "https://www.remora.com.tr/wp-content/uploads/2025/05/3.jpg",
      ],
      
      details: t("product.product_2.details"),
     
    },
    {
      id: 3,
      name: t("product.product_3.name"),
      description: t("product.product_3.description"),
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/netapros2.png",
      videoUrl: "https://www.youtube.com/watch?v=jDPzI9HORjY",
      additionalImage: "https://www.remora.com.tr/wp-content/uploads/2024/05/Goruntu-16.04.2024-11.08-scaled-e1715327213932.jpeg",
      images: [
        "https://www.remora.com.tr/wp-content/uploads/2025/05/background-1.jpg",
        "https://www.remora.com.tr/wp-content/uploads/2025/05/netapros.jpg"
      ],
      details: t("product.product_3.details"),
      specifications: {
        girişGüçKaynağı: "220 V AC 50/60 Hz",
        çıkışGüçKaynağı: "24 V DC",
        güçTüketimi: "740W",
        hariciGüçKutusuBoyutları: "41cm x 34cm x 21cm",
        temizlemeKapasitesi: "7 m²/dk",
        kabloUzunluğu: "30 m",
        fırçaDeğiştirilebilir: "Evet",
      },
      technicalInfo: {
        ağırlık: "9,5 kg",
        robotölçüleri: "42cm x 42cm x 22cm",
        filtreHacmi: "42 cm³",
      },
    },
    
    
  ];
  const products = getProducts(t);
  
  const productId = id.toString();
  const key = `product.product_${productId}`; // <-- Sonra key oluştur
  console.log("Çeviri anahtarı (key):", key); // <-- Konsola yaz




  const isMobile = useMediaQuery("(max-width:900px)"); // Mobil kontrolü
  
  const navigate = useNavigate();
  const product = products.find((product) => product.id === parseInt(id));

  const defaultImage = "https://via.placeholder.com/400";
  const initialImage = product?.image || defaultImage;
  const [selectedImage, setSelectedImage] = useState(initialImage);
  const images = product.images || [];





  if (!product) {
    return <Typography variant="h5">Ürün bulunamadı</Typography>;
  }

  




  
  return (
    <Box sx={{ display: "flex", flexDirection: "column", padding: "20px", background: "#f1f1f1" }}>
      <ArrowBackIos
        onClick={() => navigate("/urunler")}
        sx={{
          position: "absolute",
          left: 20,
          cursor: "pointer",
          color: "black",
          fontSize: 40,
        }}
      />
  
      <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: "20px" }}>
        {/* Görsel ve Thumbnail'ler */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
          <img
            src={selectedImage}
            alt={product.name}
            style={{
              width: "100%",
              maxHeight: "400px",
              objectFit: "contain",
              marginBottom: "20px",
            }}
          />
  
          <Box sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
            {images.length > 0 &&
              images.map((image, index) => (
                <Box key={index} sx={{ margin: "0 10px", cursor: "pointer" }}>
                  <img
                    src={image}
                    alt={`thumbnail-${index}`}
                    style={{ width: "100px", height: "auto", borderRadius: "10px" }}
                    onClick={() => setSelectedImage(image)}
                  />
                </Box>
              ))}
          </Box>
        </Box>
  
        {/* Ürün Detayları */}
        <Box
          sx={{
            flex: 1,
            padding: "20px",
            overflowY: "auto",
            maxHeight: "80vh",
            display: "flex",
            flexDirection: "column",
          }}
        >

          <Typography variant="h3" fontWeight="bold">{t(`${key}.name`)} </Typography>
          <Typography variant="h5" mt={2}>{t(`${key}.description`)}</Typography>
  
          {/* Ürün Detayları Bölümü */}
          <Box mt={3}>
            <Typography variant="h6">{t('ProductDetail.features.title5')}</Typography>
            <Typography variant="body1" mt={1}>{t(`${key}.details`)}</Typography>
          </Box>
  
          {/* Özellikler Bölümü */}
          <Box mt={3}>
            <Typography variant="h6"> {t('ProductDetail.features.title')}</Typography>
            {product.name === "Neta Sonic" ? (
              <>
                <Typography variant="body1">✔ {t('ProductDetail.features.netasonic')}</Typography>
                <Typography variant="body1">✔ {t('ProductDetail.features.netasonic2')}</Typography>
                <Typography variant="body1">✔ {t('ProductDetail.features.netasonic3')}</Typography>
                <Typography variant="body1">✔ {t('ProductDetail.features.netasonic4')}</Typography>
              </>
            ) : (
              <>
                <Typography variant="body1">✔ {t('ProductDetail.features.netapro')} {product.specifications.girişGüçKaynağı}</Typography>
                <Typography variant="body1">✔ {t('ProductDetail.features.netapro2')} {product.specifications.çıkışGüçKaynağı}</Typography>
                <Typography variant="body1">✔ {t('ProductDetail.features.netapro3')} {product.specifications.güçTüketimi}</Typography>
                <Typography variant="body1">✔{t('ProductDetail.features.netapro4')} {product.specifications.hariciGüçKutusuBoyutları}</Typography>
                <Typography variant="body1">✔ {t('ProductDetail.features.netapro5')}{product.specifications.temizlemeKapasitesi}</Typography>
                <Typography variant="body1">✔{t('ProductDetail.features.netapro6')} {product.specifications.kabloUzunluğu}</Typography>
                <Typography variant="body1">✔ {t('ProductDetail.features.netapro7')}{product.specifications.fırçaDeğiştirilebilir}</Typography>
              </>
            )}
          </Box>
  
          {/* Teknik Bilgiler Bölümü */}
          <Box mt={3}>
            <Typography variant="h6">{t('ProductDetail.features.title2')}</Typography>
            {product.name === "Neta Sonic" ? (
              <>
                <Typography variant="body1">✔ {t('ProductDetail.features.netasonic5')}</Typography>
                <Typography variant="body1">✔ {t('ProductDetail.features.netasonic6')}</Typography>
              </>
            ) : ( 
              <>
                <Typography variant="body1">✔ {t('ProductDetail.features.netapro8')}  {product.technicalInfo.ağırlık}</Typography>
                <Typography variant="body1">✔ {t('ProductDetail.features.netapro9')} {product.technicalInfo.robotölçüleri}</Typography>
                <Typography variant="body1">✔ {t('ProductDetail.features.netapro10')}  {product.technicalInfo.filtreHacmi}</Typography>
              </>
            )}
          </Box>
        </Box>
      </Box>


{/* Ürün Başlığı ve Resim */}
{(product.name === "Neta Pro") && (
<Box mt={3} sx={{
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  justifyContent: "space-between",
  width: "100%",
  gap: "20px",
  padding: "20px",
  backgroundColor: "#fff",  // Beyaz arka plan
  borderRadius: "8px",  // Yuvarlatılmış köşeler
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Hafif gölge
}}>
  {/* Sol Taraf - Yazılar */}

  <Box sx={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: { xs: "100%", sm: "50%" },
    textAlign: "center", // Metni ortaladık
    alignItems: "center", // Yazıları merkeze yerleştirmek için
  }}>
    <Typography variant="h4" fontWeight="bold" color="#000000" sx={{ fontSize: "24px" }}>
    {t('ProductDetail.features.text')}
    </Typography>
    
  </Box>
  
  

  {/* Sağ Taraf - Resim */}
  <Box sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: { xs: "100%", sm: "50%" },
    borderRadius: "8px", // Resmin yuvarlatılmış köşeleri
    overflow: "hidden", // Resmin taşmasını engelliyoruz
  }}>
    <img
      src={product.additionalImage || defaultImage}
      alt="Image2"
      style={{
        width: "100%",
        height: "auto",
        maxHeight: "400px",
        objectFit: "cover", // Resmi orantılı şekilde dolduruyor
        borderRadius: "8px", // Resmi yuvarlatılmış köşelere sahip yapmak için
      }}
    />
  </Box>
</Box>
)}
{/* Ürün Başlığı ve Resim */}
{(product.name === "Neta Pro S") && (
<Box mt={3} sx={{
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  justifyContent: "space-between",
  width: "100%",
  gap: "20px",
  padding: "20px",
  backgroundColor: "#fff",  // Beyaz arka plan
  borderRadius: "8px",  // Yuvarlatılmış köşeler
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Hafif gölge
}}>
  {/* Sol Taraf - Yazılar */}

  <Box sx={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: { xs: "100%", sm: "50%" },
    textAlign: "center", // Metni ortaladık
    alignItems: "center", // Yazıları merkeze yerleştirmek için
  }}>
    <Typography variant="h4" fontWeight="bold" color="#000000" sx={{ fontSize: "24px" }}>
    {t('ProductDetail.features.text2')}
   
    </Typography>

  </Box>
  
  

  {/* Sağ Taraf - Resim */}
  <Box sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: { xs: "100%", sm: "50%" },
    borderRadius: "8px", // Resmin yuvarlatılmış köşeleri
    overflow: "hidden", // Resmin taşmasını engelliyoruz
  }}>
    <img
      src={product.additionalImage || defaultImage}
      alt="Image2"
      style={{
        width: "100%",
        height: "auto",
        maxHeight: "400px",
        objectFit: "cover", // Resmi orantılı şekilde dolduruyor
        borderRadius: "8px", // Resmi yuvarlatılmış köşelere sahip yapmak için
      }}
    />
  </Box>
</Box>
)}

{/* Ürün Başlığı ve Resim */}
{(product.name === "Neta Sonic") && (
<Box mt={3} sx={{
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  justifyContent: "space-between",
  width: "100%",
  gap: "20px",
  padding: "20px",
  backgroundColor: "#fff",  // Beyaz arka plan
  borderRadius: "8px",  // Yuvarlatılmış köşeler
  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Hafif gölge
}}>
  {/* Sol Taraf - Yazılar */}

  <Box sx={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: { xs: "100%", sm: "50%" },
    textAlign: "center", // Metni ortaladık
    alignItems: "center", // Yazıları merkeze yerleştirmek için
  }}>
    <Typography variant="h4" fontWeight="bold" color="#000000" sx={{ fontSize: "24px" }}>
    {t('ProductDetail.features.text3')}
    </Typography>
  </Box>
  
  

  {/* Sağ Taraf - Resim */}
  <Box sx={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: { xs: "100%", sm: "50%" },
    borderRadius: "8px", // Resmin yuvarlatılmış köşeleri
    overflow: "hidden", // Resmin taşmasını engelliyoruz
  }}>
    <img
      src={product.additionalImage || defaultImage}
      alt="Image2"
      style={{
        width: "100%",
        height: "auto",
        maxHeight: "400px",
        objectFit: "cover", // Resmi orantılı şekilde dolduruyor
        borderRadius: "8px", // Resmi yuvarlatılmış köşelere sahip yapmak için
      }}
    />
  </Box>
</Box>
)}

{/* Sadece "Neta Pro" ve "Neta Pro S" İçin Ek Görsel */}
{(product.name === "Neta Pro" || product.name === "Neta Pro S") && (
  <Box
    mt={3}
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      flexWrap: "wrap", // Flex öğelerinin satırlara taşmasını sağlıyoruz
      gap: 3,  // Görseller ve metinler arasındaki boşluk
    }}
  >
    <Typography
      variant="h4"
      sx={{
        width: "100%",
        textAlign: "center",
        marginBottom: "24px", // Başlık ile kartlar arasındaki boşluk
        fontWeight: "bold",
        color: "#000000",
      }}
    >
         {t('ProductDetail.features.title3')}
     
    </Typography>

    {[  
      {
        img: "https://www.remora.com.tr/wp-content/uploads/2025/05/filtreresmi1.jpeg",
        text: t('ProductDetail.features.text4')
      },
      {
        img: "https://www.remora.com.tr/wp-content/uploads/2025/05/filtreresmi2.jpeg",
        text: t('ProductDetail.features.text5')
      },
      {
        img: "https://www.remora.com.tr/wp-content/uploads/2025/05/filtreresmi.jpeg",
        text: t('ProductDetail.features.text6')
      },
    ].map((item, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "280px", // Kartlar sabit genişlikte
          height: "380px", // Kartlar sabit yükseklikte
          gap: 2, // Görsel ve metin arasındaki boşluk
          padding: "16px", // Padding artırıldı
          borderRadius: "12px", // Yuvarlatılmış köşeler
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Hafif gölge
          backgroundColor: "#fff", // Beyaz arka plan
          transition: "transform 0.3s ease", // Hover efektine geçiş
          '&:hover': {
            transform: "scale(1.05)", // Hover durumunda kart büyür
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)", // Hover'da daha büyük gölge
          },
        }}
      >
        {/* Görsel */}
        <Box
          component="img"
          src={item.img}
          alt={`Filtre Yerleştirme Görseli ${index + 1}`}
          sx={{
            width: "100%", // Görselin genişliği kartın genişliği kadar
            height: "200px", // Sabit yükseklik
            objectFit: "cover", // Görselin orantılı şekilde kartı doldurmasını sağlıyoruz
            borderRadius: "8px", // Görsellerin yuvarlatılmış köşeleri
            marginBottom: "12px", // Görsel ve metin arasındaki boşluk
          }}
        />

        {/* Başlık */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#000000",
            marginBottom: "12px", // Başlık ve görsel arasına boşluk
            fontSize: "18px", // Başlık boyutu
            textAlign: "center", // Başlığı kartın ortasına hizaladık
          }}
        >
          {t('ProductDetail.features.title4')} {index + 1}
        </Typography>

        {/* Metin Kutusu */}
        <Box
          sx={{
            width: "100%", // Metin kutusu da kartın genişliğinde
            padding: "10px", // Metin kutusunun iç paddingi
            textAlign: "center", // Metni ortaladık

          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "#444",
              fontSize: "16px", // Metin boyutunu artırdık
              fontFamily: "'Roboto', sans-serif", // Modern font
              lineHeight: 1.7, // Satır aralığını artırarak okunabilirliği artırdık
              fontWeight: 500, // Daha estetik bir görünüm için orta ağırlıkta font
            }}
          >
            {item.text}
          </Typography>
        </Box>
      </Box>
    ))}
  </Box>
)}


{(product.name === "Neta Pro" || product.name === "Neta Pro S") && (
<EquipmentCards/>
)}
      <FAQ />
     


    </Box>
  );
};

export default ProductDetail;
